module.exports = __webpack_public_path__ + "img/angle_30.f2e0a24b.jpg";